module.exports = __webpack_public_path__ + "img/mockupframe.ac39296f.png";